import { enumToOptions } from '@app/shared/helpers';
import { Currency } from '@app/shared/models/contracts/enums/shared-enums';

export const CURRENCY_OPTIONS = enumToOptions(Currency);
